/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-25 11:09:09
 */
import RegisterForm from "../components/RegisterForm";
import registerImage from "@/assets/images/register.png";
import "./register.less";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";
import Brand from "@/components/brand/brand";
import { useSelector } from "react-redux";
import { HOME_URL } from "@/config/config";

const Register = () => {
	const navigate = useNavigate();

	const { token } = useSelector((state: any) => state.global);
	const nickName = localStorage.getItem("nickname");
	useEffect(() => {
		if (token && nickName) {
			navigate(HOME_URL);
		}
	}, []);

	const [errorMessage, setErrorMessage] = useState<string | any>();

	return (
		<div className="register-container">
			<div className="register-left">
				<div className="brand">
					<Brand logoSize={"3rem"} fontSize={"1.75rem"} />
				</div>
				<div className="image">
					<img src={registerImage} alt="registerBg" className="image" />
				</div>
			</div>
			<div className="register-right">
				<div className="register-form">
					<div className="register-header">
						<div className="register-title">Create your account</div>
						<p className="describe">
							<CheckOutlined className="icon" />
							<span className="text">7-day free trial</span>
							<CheckOutlined className="icon" />
							<span className="text">Cancel anytime</span>
						</p>
					</div>
					<RegisterForm setErrorMessage={setErrorMessage} />
					<div className="register-footer">
						<span className="tip">Already have an account?</span>
						<Link className="linkStyle" to={"/login"} style={{ color: "#565BDD", paddingLeft: "0.5rem" }}>
							Log in
						</Link>
						<div className="bottom">
							<span>By signing up, you agree to the </span>
							<a className="link" href="/terms">
								Terms of Service
							</a>
							<span>. You also agree to receive emails from AdSurgebot.</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Register;
